<template>
	<!-- 顶部 -->
	<div class="topbar">
		<div class="logo">
			<img src="../../assets/images/qxdj_logo.png" alt="">
			<!-- <span>新时代党建</span> -->
		</div>
		<el-menu
			ref="topbar"
			:default-active="topSelect"
			class="el-menu-demo menu" mode="horizontal"
			active-text-color="#bb0000">
			<el-menu-item
				:key="index"
				@click="setNavLeft(index)"
				:index="items.meta.activeMenu"
				v-for="(items,index) in top_bar">
				<span slot="title">{{items.name}}</span>
			</el-menu-item>
		</el-menu>
		<div class="userinfo">
			<div style="display:flex;align-items:center;cursor: pointer;" 
			@click="gomess">
				<i class="el-icon-message-solid" style="color:#bb0000;"></i>
				<div class="userinfo_name">消息</div>
			</div>
			<div style="margin-right: 10px;" class="userinfo_exit" @click="goQt">返回前台</div>
			<div class="userinfo_exit" @click="exitsys">退出</div>
		</div>
	</div>
</template>

<script>
	let that;
	import { navs } from '@/router/nav.js'
	import { xtsz } from '@/axios'
	import { mapState } from "vuex"
	export default{
		computed:{
			...mapState({
				logo:state=>state.user.logo,
				flag:state=>parseInt(state.user.userinfo.flag),
				topSelect:state=>state.user.topSelect
			}),
			top_bar(){
				let data = []
				navs.forEach(item => {
					if(item.name!="消息"){
						if(item.name == "党务工作"&&this.flag == 3){
							item.redirect = "/dyxxgl"
						}
						data.push(item)
					}
				})
				return data
			},
		},
		created(){
			that = this;
			console.log(navs);
		},
		watch:{
			$route:{
				handler(news,olds){
					this.$store.commit("setTopSelect",news.matched[0].path)
					this.top_bar.forEach((item,index) => {
						if(item.name == news.matched[0].name){
							this.$store.commit("setLeftNav",this.top_bar[index].children)
							this.$store.commit("setTopInfo",this.top_bar[index])
						}
					})
				}
			}
		},
		methods:{
			// 退出系统
			exitsys(){
				// 清除token退出登录
				this.$store.commit("clearUserInfo")
			},
			gomess(){
				console.log(123);
				that.$router.push({
					path:'/mess'
				})
			},
			goQt(){
				window.location.href='http://qxzx.gxsentu.net/'
			}
			,

			goleft(index,indexpath){
				that.$router.push(index)
			},
			setNavLeft(index){
				
				that.$router.push(this.top_bar[index].redirect)
				this.$store.commit("setTopSelect",this.top_bar[index].path)
				if(index!=0){
					this.$store.commit("setLeftNav",this.top_bar[index].children)
					this.$store.commit("setTopInfo",this.top_bar[index])
					this.$store.commit("setLeftSelect",this.top_bar[index].children[0].redirect)
				}
			}
		}
	}
</script>

 <style lang="scss">
	.topbar{
		z-index: 10;
		position: fixed;
		top: 0;
		left: 0;
		color: #333333;
		display: flex;
		background: #fff;
		justify-content: space-between;
		height: 60px;
		padding: 0 18px;
		box-shadow: 0px 2px 5px 0px rgba(30, 33, 41, 0.1);
		box-sizing: border-box;
		align-items: center;
		width: 100%;
		height: 60px;
		font-size: 1em;
		border-bottom: 1px solid #f6f6f6;
		.logo{
			display: flex;
			align-items: center;
			color: #BB0000;
			font-weight: bold;
			font-size: 15px;
			margin-right: 70px;
			height: 45px;
			letter-spacing: 1px;
			img{
				height: 80%;
				margin-right: 10px;
				object-fit: scale-down;
			}
		}
		.menu{
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			flex: 1;
			margin-right: 50px;
			&_item{
				line-height: 60px;
				cursor: pointer;
				color: #3C4353;
				margin-right: 50px;
				font-size: 16px;
				border-bottom:3px solid rgba($color: #000000, $alpha: 0);
			}
			&_item:last-child{
				margin-right: 0 !important;
			}
			&_item:hover{
				border-bottom: 3px solid #BB0000;
			}
			&_item_select{
				color: #1E2129;
				border-bottom: 3px solid #BB0000 !important;
			}
		}
		.userinfo{
			display: flex;
			min-width: 200px;
			align-items: center;
			justify-content: flex-end;
			&_pic{
				width: 36px;
				height: 36px;
				background: url(../../assets/images/morenimg.png) no-repeat;
				background-size: 100% 100%;
			}
			&_name{
				font-size: 16px;
				margin:0 10px;
				font-size: 14px;
			}
			&_exit{
				cursor: pointer;
				width: 70px;
				height: 30px;
				line-height: 30px;
				text-align: center;
				color: #BB0000;
				font-size: 14px;
				border-radius: 3px;
				border: 1px solid #BB0000;
			}
		}
		.el-menu-item{
			font-size: 16px !important;
			padding: 0 1% !important;
			margin: 0 2% !important;
		}
	}
 </style>